export default __webpack_public_path__ + "static/web-logo-1-ed5a2721c24338492bcec4d1dfb8ae0c.webp";